// extracted by mini-css-extract-plugin
module.exports = {"color1":"#59c973","color2":"#37a64b"};